import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, MenuItem, Grid, IconButton, InputAdornment  } from '@mui/material';
import SalesMasterCard from './SalesMasterCard';
import PartnerModalConatiner from '../../containers/common/form/modal/PartnerModalConatiner';
import { useFormik } from 'formik';
import BaseCodeSelectbox from '../common/form/selectbox/BaseCodeSelectbox';
import ProjectModalConatiner from './ProjectModalConatiner';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const SalesActionForm = ({ selectedSchedule, onSaveAction, onDeleteAction, isSaving, onDateChange, shouldResetForm, setShouldResetForm }) => {
    const [isNewRegistration, setIsNewRegistration] = useState(false);
    const [openClient, setOpenClient] = useState(false);
    const [isLocationValid, setIsLocationValid] = useState(true); 
    
    const [openProjectModal, setOpenProjectModal] = useState(false);

    const pageUrl = "/maintancetmng";

    const handleTextClick = () => {
        if (!formData || !formData.prjUuid || String(formData.prjUuid).trim() === '' || String(formData.prjUuid) === 'null') return;

        let pageUrl = "/chancemng";

        const status = formData.cmpStatus;
        const hasStatus = status !== null && status !== undefined && String(status).trim() !== '' && String(status) !== 'null';

        let stepTarget = (formData.cstGrade !== null && formData.cstGrade !== undefined && String(formData.cstGrade) !== 'null') ? formData.cstGrade : '0';
        if (hasStatus) {
            if (String(formData.prjTyp).trim() === 'N') {
                pageUrl = "/projectmng";
            } else {
                pageUrl = "/maintancetmng";
            }
            stepTarget = (formData.cmpGrade !== null && formData.cmpGrade !== undefined && String(formData.cmpGrade) !== 'null') ? formData.cmpGrade : '0';
        }

        window.open(`${pageUrl}/${formData.prjUuid}/${stepTarget}/1`, '_blank');
    };

    const handleOpenProjectModal = () => {
        setOpenProjectModal(true);
    };

    const handleCloseProjectModal = () => {
        setOpenProjectModal(false);
    };

    const localUser = localStorage.getItem('user');
    let sessionUsrNm = '담당자 정보 없음';
    let sessionUsrUuid = '';
    let sessionDptUuid = '';

    if (localUser) {
        try {
            const parsedUser = JSON.parse(localUser);
            sessionUsrNm = parsedUser.usrNm || '담당자 정보 없음';
            sessionUsrUuid = parsedUser.userUuid || parsedUser.usrUuid || '';
            sessionDptUuid = parsedUser.dptUuid || '';
        } catch (error) {
            console.error("로컬스토리지 유저 정보 파싱 에러:", error);
        }
    }

    const [formData, setFormData] = useState({
        title: '',
        partnerTyp: '고객사',
        usrNm: sessionUsrNm,       // 🔍 신규 등록 모드 기본값 주입
        usrUuid: sessionUsrUuid,   // 🔍 신규 등록 모드 기본값 주입
        dptUuid: sessionDptUuid,   // 🔍 신규 등록 모드 기본값 주입
        startTime: '09:00',
        endTime: '18:00',
        companyNm: '',
        companyUuid: '',
        meetPlace: '',
        bizNm: '',
        content: '',
        actionType: '',
        cstNm: '',
        prjUuid: '',
        prjTyp: '',
        cmpGrade: '',
        cmpStatus: '',
        cstGrade: '',
        projectNm: '',
        customProjectNm: '',
    });

    useEffect(() => {
        if (selectedSchedule) {
            setIsNewRegistration(false);
            let parsedStart = '09:00', parsedEnd = '18:00';
            
            // 안전하게 문자열 자르기 수정 (split 괄호 오류 교정)
            if (selectedSchedule.start && selectedSchedule.start.includes(' ')) parsedStart = selectedSchedule.start.split(' ')[1].substring(0, 5);
            if (selectedSchedule.end && selectedSchedule.end.includes(' ')) parsedEnd = selectedSchedule.end.split(' ')[1].substring(0, 5);

            setFormData({
                title: `${selectedSchedule.title || ''}`,
                partnerTyp: '고객사',
                usrNm: selectedSchedule.extendedProps?.usrNm || sessionUsrNm,
                usrUuid: selectedSchedule.extendedProps?.usrUuid || sessionUsrUuid,
                dptUuid: selectedSchedule.extendedProps?.dptUuid || sessionDptUuid,
                startTime: parsedStart,
                endTime: parsedEnd,
                companyNm: selectedSchedule.extendedProps?.companyNm || '',
                companyUuid: selectedSchedule.extendedProps?.companyUuid || '',
                meetPlace: selectedSchedule.extendedProps?.meetPlace || '',
                bizNm: selectedSchedule.extendedProps?.bizNm || '',
                content: selectedSchedule.extendedProps?.content || '',
                actionType: selectedSchedule.extendedProps?.actionType || '',
                projectNm: selectedSchedule.extendedProps?.cstNm || selectedSchedule.extendedProps?.customProjectNm || '',                
                prjUuid: selectedSchedule.extendedProps?.prjUuid || '',
                prjTyp: selectedSchedule.extendedProps?.prjTyp || '',
                cmpGrade: selectedSchedule.extendedProps?.cmpGrade || '',
                cmpStatus: selectedSchedule.extendedProps?.cmpStatus || '',
                cstGrade: selectedSchedule.extendedProps?.cstGrade || '',
                customProjectNm : selectedSchedule.extendedProps?.customProjectNm || '',
            });
        }
    }, [selectedSchedule, sessionUsrNm, sessionUsrUuid]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleResetForm = () => {
        setIsNewRegistration(true);
        setFormData(prev => ({
            title: '', 
            partnerTyp: '고객사', 
            usrNm: sessionUsrNm,     // 🔍 폼 리셋(신규 전환) 시 로컬스토리지 값 재주입
            usrUuid: sessionUsrUuid, // 🔍 폼 리셋(신규 전환) 시 로컬스토리지 값 재주입
            dptUuid: sessionDptUuid, // 🔍 폼 리셋(신규 전환) 시 로컬스토리지 값 재주입
            startTime: '09:00', 
            endTime: '18:00',
            companyNm: '', 
            companyUuid: '', 
            meetPlace: '', 
            bizNm: '', 
            content: '',
            actionType: '',
            cstNm: '',
            prjUuid: '',
            prjTyp: '',
            cmpGrade: '',
            cmpStatus: '',
            cstGrade: '',
            projectNm: '',
            customProjectNm: '',
        }));
        formik.setFieldValue('actionType', '')
    };

    const handleOpenClient = () => setOpenClient(true);
    const handleCloseClient = () => setOpenClient(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (typeof onSaveAction === 'function') {
            onSaveAction({
                actionId: isNewRegistration ? null : (formData.actionId || selectedSchedule?.id || null), // 🚀 actionId 필드 명확히 포함
                title: formData.title,
                partnerTyp: formData.partnerTyp,
                usrUuid: formData.usrUuid,
                dptUuid: formData.dptUuid,
                startTime: formData.startTime,
                endTime: formData.endTime,
                companyUuid: formData.companyUuid,
                meetPlace: formData.meetPlace,
                bizNm: formData.bizNm,
                content: formData.content,
                masterId: isNewRegistration ? null : (selectedSchedule?.id || null),
                actionType: formData.actionType,
                prjUuid: formData.prjUuid || '',
                customProjectNm: formData.projectNm || '',
            }, handleResetForm);
        }
    };


    const selectedClient = (partner) => {
        if (typeof formData.setFieldValue === 'function') {
            formData.setFieldValue('companyUuid', partner.partnerUuid);
            formData.setFieldValue('companyNm', partner.partnerNm);
        } else {
            if (typeof setFormData === 'function') {
                setFormData(prev => ({
                    ...prev,
                    companyUuid: partner.partnerUuid,
                    companyNm: partner.partnerNm,
                }));
            } else {
                formData.companyUuid = partner.partnerUuid;
                formData.companyNm = partner.partnerNm;
            }
        }
        handleCloseClient();
    };
    
    const formik = useFormik({
        enableReinitialize: true, 
        initialValues: {
            actionType: formData.actionType // 💡 이제 formData가 바뀔 때마다 이 초기값도 리셋되어 getIn 매칭이 성공합니다.
        },
        onSubmit: () => {}
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        setFormData((prev) => {
            const nextData = { ...prev, [name]: value };
            
            // 💡 [데이터 일치화]: 사용자가 인풋창에 사업명을 직접 타이핑해서 수정하면
            // 모달로 가져왔던 고유 ID(prjUuid)를 비워두어 꼬임을 방지합니다.
            if (name === 'projectNm') {
                nextData.prjUuid = ''; 
            }

            // 📅 [기존 날짜 동기화]: 시작일 변경 시 종료일 자동 동기화
            if (name === 'startDate') {
                nextData.endDate = value;
            }
            
            return nextData;
        });
    };

    const handleSelectProject = (projectData) => {
        setFormData(prev => ({
            ...prev,
            projectNm: projectData.cstNm,
            prjUuid: projectData.prjUuid 

        }));
        setOpenProjectModal(false); // 선택 완료 후 모달 닫기
    };

    useEffect(() => {
        setFormData(prev => ({ ...prev, actionType: formik.values.actionType }));
    }, [formik.values.actionType]);

    useEffect(() => {
    if (shouldResetForm) {
        handleResetForm();
        setShouldResetForm(false); 
    }
    }, [shouldResetForm, setShouldResetForm]); 

    const formFields = [
        { name: 'title', label: '제목', sm: 12, required: true, placeholder: '제목을 입력하세요' },
        { name: 'usrNm', label: '담당자명', sm: 6, readOnly: true },
        { name: 'startTime', label: '시작 시간', sm: 6, type: 'time' },
        { name: 'endTime', label: '종료 시간', sm: 6, type: 'time' },
        { name: 'meetPlace', label: '장소', sm: 6, placeholder: '미팅 장소 또는 위치 입력' }
    ];


    return (
        <Box 
            component="form" 
            onSubmit={handleSubmit}
            sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                gap: 2.5,
                height: '100%',
                maxHeight: '80vh',
                overflowY: 'auto',
                pr: 0.5
            }}
        >
            <SalesMasterCard 
                selectedSchedule={selectedSchedule}
                isNewRegistration={isNewRegistration}
                handleResetForm={handleResetForm}
                handleDisconnectSchedule={() => setIsNewRegistration(true)}
            />

                <Grid container spacing={2}>
                {formFields.map((field) => {
                    if (field.name === 'usrNm') {
                        return (
                            <React.Fragment key="usrNm-group-section">
                                <Grid item xs={12} sm={6} key="actionType-section">
                                    <Box 
                                        sx={{ 
                                            width: '100%',
                                            '& .MuiFormControl-root': { width: '100%' },
                                            '& .MuiInputLabel-root': { 
                                                fontSize: '1rem', 
                                                transform: 'translate(14px, 8px) scale(1)', 
                                                background: '#ffffff', 
                                                px: '5px' 
                                            },
                                            '& .MuiInputLabel-shrink': { 
                                                fontSize: '1rem !important', 
                                                transform: 'translate(14px, -7px) scale(0.75) !important',
                                                fontWeight: 500
                                            },
                                            '& .MuiOutlinedInput-root': { 
                                                borderRadius: '6px' 
                                            },
                                            '& .MuiSelect-select': {
                                                py: '8.5px',
                                                fontSize: '1rem'
                                            }
                                        }}
                                    >
                                        <BaseCodeSelectbox
                                            formik={formik}
                                            filterObject={{
                                                blcCd: 'BASE',
                                                mlcCd: 'SALES_ACTION',
                                                slcCd: 'ACT_TYP',
                                                useYn: 'Y',
                                            }}
                                            name="actionType"
                                            label="업무구분"
                                            size="small"
                                            required={true}
                                        />
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={field.sm} key={field.name}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        label={field.label}
                                        name={field.name}
                                        type={field.type || 'text'}
                                        value={formData[field.name]}
                                        onChange={handleInputChange}
                                        InputProps={field.readOnly ? { readOnly: true } : undefined}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '6px' } }}
                                    />
                                </Grid>
                            </React.Fragment>
                        );
                    }

                    if (field.name === 'meetPlace') {
                        return (
                            <React.Fragment key="company-section">
                                <Grid item xs={12} sm={6}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs={8}>
                                            <TextField
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                label="업체명"
                                                name="companyNm"
                                                value={formData.companyNm}
                                                InputProps={{ readOnly: true }}
                                                placeholder="우측 버튼으로 선택하세요"
                                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '6px' } }}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Button
                                                fullWidth
                                                color="secondary"
                                                variant="outlined"
                                                size="small"
                                                onClick={handleOpenClient}
                                                disabled={!isLocationValid} 
                                                sx={{ 
                                                    height: '40px', 
                                                    whiteSpace: 'nowrap',
                                                    px: '8px', 
                                                    fontSize: '0.8rem',
                                                    borderRadius: '6px'
                                                }} 
                                            >
                                                고객사 선택
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                                <Grid item xs={12} sm={field.sm} key={field.name}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        label={field.label}
                                        name={field.name}
                                        type={field.type || 'text'}
                                        placeholder={field.placeholder || ''}
                                        value={formData[field.name]}
                                        onChange={handleInputChange}
                                        sx={{ '& .MuiOutlinedInput-root': { borderRadius: '6px' } }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
    <Grid container spacing={1} alignItems="center">
        <Grid item xs={10}> 
            <TextField
                fullWidth
                size="small"
                variant="outlined"
                label="사업명"
                name="projectNm"
                value={formData.projectNm || ''}
                onChange={handleChange} 
                placeholder={formData.prjUuid ? "우측 링크 아이콘을 눌러 상세 정보를 확인하세요" : "사업명을 직접 입력하거나 우측 버튼으로 선택하세요"}
                
                // ⛔ [버그 해결]: 인풋창 자체의 onClick은 깨끗하게 제거하여 
                // 글자 클릭, 커서 이동, 수동 타이핑 수정이 먹통이 되는 현상을 완벽히 해결합니다.

                InputProps={{
                    // 🚀 [링크 이동 기능 안정적 결합]: 공식 프로젝트(prjUuid 존재)일 때만 인풋창 안쪽 우측 끝에 링크 아이콘을 띄웁니다.
                    endAdornment: formData.prjUuid && typeof handleTextClick === 'function' ? (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation(); // 부모 인풋창으로 이벤트가 퍼지는 것 차단
                                    handleTextClick(e);  // 💫 오직 이 아이콘을 클릭했을 때만 안전하게 링크 이동 실행
                                }}
                                title="상세 페이지 이동"
                                sx={{ color: '#228be6' }}
                            >
                                <OpenInNewIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null
                }}
                
                sx={{ 
                    '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                    /* 🎯 공식 선택 시 파란색 스타일, 직접 타이핑 시 일반 검정색 텍스트 실시간 스위칭 */
                    '& .MuiInputBase-input': {
                        cursor: 'text !important', // 💡 항시 타이핑 커서(text)로 고정하여 수정 가능하게 처리
                        color: formData.prjUuid ? '#228be6 !important' : '#333333 !important', 
                        fontWeight: formData.prjUuid ? '600 !important' : '500 !important',
                        textDecoration: formData.prjUuid ? 'underline !important' : 'none !important',
                        WebkitTextFillColor: formData.prjUuid ? '#228be6 !important' : '#333333 !important'
                    }
                }}
            />
        </Grid>
        
        {/* 🎯 사업명 선택 버튼 */}
        <Grid item xs={2}>
            <Button
                fullWidth
                color="primary"
                variant="outlined"
                size="small"
                onClick={handleOpenProjectModal}
                sx={{ 
                    height: '40px', 
                    whiteSpace: 'nowrap',
                    px: '8px', 
                    fontSize: '0.8rem',
                    borderRadius: '6px'
                }} 
            >
                사업명 선택
            </Button>
        </Grid>
    </Grid>
</Grid>

                            </React.Fragment>
                        );
                    }

                    return (
                        <Grid item xs={12} sm={field.sm} key={field.name}>
                            <TextField
                                fullWidth
                                size="small"
                                variant="outlined"
                                label={field.label}
                                name={field.name}
                                type={field.type || 'text'}
                                select={field.select || false}
                                required={field.required || false}
                                placeholder={field.placeholder || ''}
                                value={formData[field.name]}
                                onChange={handleInputChange}
                                InputProps={field.readOnly ? { readOnly: true } : undefined}
                                InputLabelProps={field.type === 'time' ? { shrink: true } : undefined}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '6px' } }}
                            >
                                {field.select && field.options?.map((opt) => (
                                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    );
                })}
            </Grid>
            <TextField
                fullWidth
                multiline
                rows={10}
                label="상세 내용"
                name="content"
                value={formData.content}
                onChange={handleInputChange}
                variant="outlined"
                placeholder="영업 활동 내용 및 특이사항을 상세히 기술하세요."
                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '6px' } }}
            />

                        <Box 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end', 
                    alignItems: 'center', 
                    mt: 'auto', 
                    pt: 2,
                    gap: 1.5
                }}
            >
                {(!isNewRegistration && (formData.actionId || selectedSchedule?.id)) && (
                    <Button
                        variant="outlined"
                        color="error"
                        disabled={isSaving}
                        onClick={() => {
                            const targetId = formData.actionId || selectedSchedule?.id;
                            if (targetId && typeof onDeleteAction === 'function') {
                                // 🚀 두 번째 인자로 자식의 리셋 함수(handleResetForm)를 함께 전달합니다!
                                onDeleteAction(targetId, handleResetForm);
                            }
                        }}
                        sx={{ 
                            px: 3, 
                            py: 1, 
                            fontWeight: 'bold', 
                            borderRadius: '6px'
                        }}
                    >
                        삭제
                    </Button>
                )}

                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSaving}
                    sx={{ 
                        px: 4, 
                        py: 1, 
                        fontWeight: 'bold', 
                        borderRadius: '6px',
                        boxShadow: 'none',
                        '&:hover': { boxShadow: 'none' }
                    }}
                >
                    저장
                </Button>
            </Box>
            {openClient && (
                <PartnerModalConatiner
                    link
                    title="고객사 선택"
                    open={openClient}
                    handleClose={handleCloseClient}
                    selectedPartner={selectedClient}
                    selectedPartnerTyp={'고객사'}
                    isModal={true}
                />
            )}
            {openProjectModal && (
                <ProjectModalConatiner
                    open={openProjectModal}
                    onClose={handleCloseProjectModal}
                    onSelectSchedule={handleSelectProject} // 선택 시 데이터 바인딩 핸들러 호출
                />
            )}
        </Box>
    );
};

export default SalesActionForm;
